import type { TourId } from './types';

export type TourAnchorOutcome = 'anchored' | 'centered' | 'fallback';

export type TourAnchorFailureReason = 'not-found' | 'off-screen';

export type TourEnd = 'tour-completed' | 'tour-dismissed';

export type TourFeedbackSentiment = 'positive' | 'negative';

type TourStepEvent = {
  tourId: TourId;
  stepId: string;
  stepNumber: number;
  totalSteps: number;
};

export type TourTrackingEvent =
  | {
      type: 'tour-started';
      tourId: TourId;
      totalSteps: number;
      startStepNumber: number;
    }
  | ({
      type: 'step-viewed';
      anchorOutcome: TourAnchorOutcome;
    } & TourStepEvent)
  | ({
      type: 'step-anchor-failed';
      reason: TourAnchorFailureReason;
    } & TourStepEvent)
  | {
      type: TourEnd;
      tourId: TourId;
      stepNumber: number;
      totalSteps: number;
      durationSeconds: number;
    }
  | {
      type: 'tour-feedback-given';
      tourId: TourId;
      sentiment: TourFeedbackSentiment;
      stepNumber: number;
      totalSteps: number;
    };

export const tourTrackingEventNames: Record<TourTrackingEvent['type'], string> =
  {
    'tour-started': 'Product tours0 started tour',
    'step-viewed': 'Product tours0 viewed step',
    'step-anchor-failed': 'Product tours0 failed to anchor step',
    'tour-completed': 'Product tours0 ended tour',
    'tour-dismissed': 'Product tours0 dismissed tour',
    'tour-feedback-given': 'Product tours0 gave tour feedback',
  };

export const toTourEventMetadata = <T extends TourTrackingEvent>({
  type: _type,
  ...metadata
}: T): Omit<T, 'type'> => metadata;

export type TrackTourEvent = (event: TourTrackingEvent) => void;

export const noTourTracking: TrackTourEvent = () => {};
